export default "__VITE_ASSET__82d58338__"